import React, { useCallback, useMemo } from 'react';

import { ValueStepper } from '@fhs-legacy/universal-components';
import { useCRMEventsContext } from 'state/crm-events';

import { ModifierListItem } from './modifier-list-item';
import { IModifierTypeUIProps } from './types';
import {
  getModifierOptionMultipliers,
  getSingleSelectedOption,
  logProductModifierCustomization,
  transformSelectedValueToSelections,
} from './utils';

export const ModifierNumeric = ({
  modifier,
  selections,
  onSelectionsChange,
  selectedItem,
}: IModifierTypeUIProps) => {
  const selectedOption = useMemo(() => getSingleSelectedOption(selections), [selections]);
  const selectedOptionIndex = useMemo(
    () => modifier.options.findIndex(opt => opt._key === selectedOption._key),
    [modifier.options, selectedOption._key]
  );
  const { logRBIEvent } = useCRMEventsContext();
  const handleNumberInputChange = useCallback(
    (newOptionsValue: number) => {
      const selection = transformSelectedValueToSelections(modifier.options, newOptionsValue);
      const newSelectedOption = Object.values(selection)[0];
      onSelectionsChange(selection);
      logProductModifierCustomization(
        newSelectedOption?.name?.locale ?? '',
        modifier.name.locale,
        newSelectedOption?._key,
        logRBIEvent
      );
    },
    [modifier.options, onSelectionsChange]
  );
  const options = getModifierOptionMultipliers(modifier.options);

  return (
    <ModifierListItem
      content={modifier}
      options={modifier.options}
      selectedOption={selectedOption}
      selectedItem={selectedItem}
      controls={
        <ValueStepper<number>
          testID="modifier-number-input"
          defaultValue={options[selectedOptionIndex].value}
          value={options[selectedOptionIndex].value}
          onChangeValue={handleNumberInputChange}
          options={options}
          accessibilityHint=""
          accessibilityLabel=""
          _decrementButton={{
            height: 6,
            width: 6,
          }}
          _incrementButton={{
            height: 6,
            width: 6,
          }}
          _selectedOptionLabel={{
            alignItems: 'center',
            justifyContent: 'center',
            height: 12,
            width: 12,
            marginX: 2,
            marginY: 0,
          }}
          space={0}
        />
      }
    />
  );
};
